// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import router from './router'
import "babel-polyfill"
import api from './utils'
import './rules/rules'


import $ from 'jquery'
import 'bootstrap3/dist/css/bootstrap.min.css'
import 'bootstrap3/dist/js/bootstrap.min.js'
import App from './App'
import Msg from './components/Msg/Msg'

import VueI18n from 'vue-i18n'
import EN from './lang/en.js'
import CN from './lang/cn.js'
import CHT from './lang/cht.js'
import JP from './lang/jp.js'

Vue.use(VueI18n)
Vue.locale = ()=>{}

Vue.prototype.$api = api
Vue.config.productionTip = false
Vue.use(Msg)

const messages = {
  EN:EN,
  CN:CN,
  CHT:CHT,
  JP:JP
}
const i18n = new VueI18n({
  locale:localStorage.getItem("lang") || "EN",
  messages
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  i18n,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js